// extracted by mini-css-extract-plugin
export default {"sidemenuItem":"SidemenuLink_sidemenuItem__c68cP","sidemenuName":"SidemenuLink_sidemenuName__Yk8XH","activeLink":"SidemenuLink_activeLink__XueA8"};